import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { NotificationService } from 'src/app/core/services/notification.service';
import { AdminUpdateNoteService } from '../../services/update-note.service';
import { UpdateNote } from 'src/app/update-notes/types/update-note';

const PREVIEW_LENGTH = 120;

@Component({
  selector: 'app-manage-update-notes',
  imports: [
    CommonModule,
    RouterLink,
    ButtonModule,
    TableModule,
    TooltipModule,
    ConfirmDialogModule,
  ],
  templateUrl: './manage-update-notes.component.html',
})
export class ManageUpdateNotesComponent implements OnInit {
  updateNoteService = inject(AdminUpdateNoteService);
  private confirmationService = inject(ConfirmationService);
  private notificationService = inject(NotificationService);

  ngOnInit(): void {
    this.updateNoteService.loadNotes();
  }

  preview(note: UpdateNote): string {
    const firstLine = note.contentFR.split('\n')[0];
    return firstLine.length > PREVIEW_LENGTH
      ? `${firstLine.slice(0, PREVIEW_LENGTH)}…`
      : firstLine;
  }

  confirmDelete(note: UpdateNote): void {
    this.confirmationService.confirm({
      header: 'Delete update note',
      message: `Delete the update note released on ${note.releasedAt.slice(0, 10)}? This cannot be undone.`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Yes',
      rejectLabel: 'No',
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-text',
      accept: () => this.delete(note.id),
    });
  }

  private delete(id: string): void {
    this.updateNoteService.deleteNote(id).subscribe({
      next: () => this.notificationService.success('Update note deleted'),
      error: () =>
        this.notificationService.error('Could not delete the update note'),
    });
  }
}
